import { render, staticRenderFns, recyclableRender, components } from "./suggest.vue?vue&type=template&id=443abec1&scoped=true&"
var renderjs
import script from "./suggest.vue?vue&type=script&lang=js&"
export * from "./suggest.vue?vue&type=script&lang=js&"
import style0 from "./suggest.vue?vue&type=style&index=0&id=443abec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443abec1",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/suggest.vue"
export default component.exports